module.exports = __webpack_public_path__ + "img/au011.78c81cee.jpg";